/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { FC } from 'react'
import referentApi from "../../modules/tp/referents/_requests";
import { Referent, emptyReferent } from "app/modules/tp/referents/_models";
import { Column } from "app/partials/entity/Table";
import ReferentFormBuilder from "app/modules/tp/referents/builders/ReferentFormBuilder";
import PageWrapper from "app/partials/entity/PageWrapper";

const columns: Array<Column<Referent>> = [
    {
        key: "name",
        label: "Nome",
        filterable: true,
        sortable: true,
    },
    {
        key: "surname",
        label: "Cognome",
        filterable: true,
        sortable: true,
    },
    {
        key: "phone",
        label: "Telefono",
        filterable: true,
        sortable: true,
    },
    {
        key: "email",
        label: "Email",
        filterable: true,
        sortable: true,
    },
]

const entityIcon = "fa-solid fa-user-tie";

const ReferentsPage: FC = () => {
    return (
                <PageWrapper
                    columns={columns}
                    emptyEntity={emptyReferent}
                    entityIcon={entityIcon}
                    entityApi={referentApi}
                    labels={{
                        icon: entityIcon,
                        singleEntityName: "Referente",
                        pluralEntityName: "Referenti",
                    }}
                    form={ReferentFormBuilder()}
                />
    );
}


export { ReferentsPage }
